import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const OPEN_RECORD_PROFILE = "onOpenRecordProfile";
